// Side-effect imports
// Must register its popstate listener before Turbo's — keep this the first import.
import '../helpers/history_guard'
import 'bootstrap'

// Library imports
import { Turbo } from '@hotwired/turbo-rails'
import ReactRailsUJS from 'react_ujs'
import reactTurboEvents from '../helpers/react_rails_ujs_turbo_events_shim'
import Rails from '@rails/ujs'

// Stimulus imports and initialization
import { Application as Stimulus } from '@hotwired/stimulus'
import Reveal from 'stimulus-reveal-controller'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'

// Stylesheets
import '../src/volunteer.scss'
import { registerGaletteControllers } from '@mes-amis/galette-design-system/stimulus'

// Rails UJS
Rails.start()

// Turbo
Turbo.session.drive = true

// Stimulus
const stimulusApp = Stimulus.start()
stimulusApp.register('reveal', Reveal)

const volunteerControllersContext = require.context('controllers/volunteer', true, /^(?!.*__tests__).*\.js$/)
stimulusApp.load(definitionsFromContext(volunteerControllersContext))

const sharedInputsContext = require.context('controllers/shared/inputs', true, /^(?!.*__tests__).*\.js$/)
stimulusApp.load(definitionsFromContext(sharedInputsContext))

const sharedContext = require.context('controllers/shared', true, /^(?!.*__tests__).*\.js$/)
stimulusApp.load(definitionsFromContext(sharedContext))
// design-system controllers (ui--button, ui--modal--dialog, tooltip, ...)
registerGaletteControllers(stimulusApp)

window.stimulusApp = stimulusApp

// React
ReactRailsUJS.useContext(require.context('components', true))
reactTurboEvents.setup(ReactRailsUJS)
